module.exports = __webpack_public_path__ + "img/img11.354a9b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img11.jpg
// module id = 307
// module chunks = 0